(function(){
  var INIT_ATTR = 'data-cn-initialized';

  function rand(min, max){ return Math.floor(Math.random() * (max - min + 1)) + min; }

  function initOne(container){
    if (!container || container.getAttribute(INIT_ATTR) === 'true') return;
    var numberEl = container.querySelector('.cn-widget__number');
    if (!numberEl) return;

    var min = parseInt(container.getAttribute('data-min')) || 2;
    var max = parseInt(container.getAttribute('data-max')) || 5;
    var interval = parseInt(container.getAttribute('data-interval')) || 4000;

    function update(){
      numberEl.classList.add('updating');
      setTimeout(function(){
        numberEl.textContent = String(rand(min, max));
        numberEl.classList.remove('updating');
      }, 140);
    }

    numberEl.textContent = String(rand(min, max));
    var timer = setInterval(update, interval);

    container.setAttribute(INIT_ATTR, 'true');
    container._cnCleanup = function(){ clearInterval(timer); container.removeAttribute(INIT_ATTR); };
  }

  function initAll(root){ (root || document).querySelectorAll('.cn-widget').forEach(initOne); }

  // Start na zwykłym ładowaniu
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  // Edytor motywu / dynamiczne sekcje
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('shopify:section:unload', function(e){
    e.target.querySelectorAll('.cn-widget').forEach(function(el){ if (el._cnCleanup) el._cnCleanup(); });
  });

  // Niektóre motywy mają nawigację AJAX
  document.addEventListener('page:load', function(){ initAll(document); });

  // Reaguj na dynamiczne dodanie/usunięcie bloku
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(node){
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('.cn-widget')) initOne(node);
        node.querySelectorAll && node.querySelectorAll('.cn-widget').forEach(initOne);
      });
      m.removedNodes && m.removedNodes.forEach(function(node){
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('.cn-widget') && node._cnCleanup) node._cnCleanup();
        node.querySelectorAll && node.querySelectorAll('.cn-widget').forEach(function(el){ if (el._cnCleanup) el._cnCleanup(); });
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
